import API, { graphqlOperation } from "@aws-amplify/api";
import * as mutations from "../../graphql/mutations";
import * as queries from "../../graphql/queries";
import { makeGraphQLRequest } from "..";
const createSite = async (object) => {
  try {
    return makeGraphQLRequest(
      graphqlOperation(mutations.createSite, { input: object })
    );
  } catch (error) {
    console.error("Error creating Site:", error);
    throw error;
  }
};

const updateSite = async (id, args) => {
  try {
    // First, fetch the current version of the Site
    const getSiteResponse = await makeGraphQLRequest(
      graphqlOperation(queries.getSite, { id })
    );
    const currentSite = getSiteResponse.data.getSite;

    // Prepare the update input
    const updateInput = { id, _version: currentSite._version };
    args.forEach((arg) => {
      updateInput[arg.property] = arg.value;
    });

    return makeGraphQLRequest(
      graphqlOperation(mutations.updateSite, { input: updateInput })
    );
  } catch (error) {
    console.error("Error updating Site:", error);
    throw error;
  }
};

const deleteSite = async (id) => {
  try {
    // First, fetch the current version of the Site
    const getSiteResponse = await makeGraphQLRequest(
      graphqlOperation(queries.getSite, { id })
    );
    const currentSite = getSiteResponse.data.getSite;

    const response = await makeGraphQLRequest(
      graphqlOperation(mutations.deleteSite, {
        input: { id, _version: currentSite._version },
      })
    );
    return response.data.deleteSite;
  } catch (error) {
    console.error("Error deleting Site:", error);
    throw error;
  }
};

const getSitesByWorkspaceID = (workspaceID) =>
  makeGraphQLRequest(
    graphqlOperation(queries.sitesByWorkspace, { workspaceID: workspaceID })
  );

export default {
  createSite,
  updateSite,
  deleteSite,
  getSitesByWorkspaceID,
};
